import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormGroup,
  Box,
  Paper,
  Divider,
  Chip,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { ReactComponent as EditIconTwo } from "Assets/Icons/EditIconTwo.svg";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { ReactComponent as ErrorIcon } from "Assets/Icons/ErrorIcon.svg";
import clsx from "clsx";
import DrugAutoComplete from "Components/Patients/DrugAutoComplete";
import { ReactComponent as AddIcon } from "Assets/Icons/AddIcon.svg";
import PageLoading from "Components/Common/PageLoading";
import HtmlTooltipMain from "Components/Common/HtmlTooltipMain";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import WarningIcon from "@mui/icons-material/Warning";
import RepeatOrderPatientAutoComplete from "Components/RepeatOrder/RepeatOrderPatientAutoComplete";
import SurgryAutoComplete from "Components/Patients/SurgeryAutoComplete";
import PharmacyAutoComplete from "Components/Patients/PharmacyAutoComplete";
// const RepeatOrderPatientAutoComplete = React.lazy(() =>
//   import("Components/RepeatOrder/RepeatOrderPatientAutoComplete")
// );
// const SurgryAutoComplete = React.lazy(() =>
//   import("Components/Patients/SurgeryAutoComplete")
// );
// const PharmacyAutoComplete = React.lazy(() =>
//   import("Components/Patients/PharmacyAutoComplete")
// );

const useStyle = makeStyles((theme) => ({
  tableHead: {
    "&>tr": {
      "&>th": {
        padding: "7px 13px !important",
      },
    },
  },
  managePageH: {
    maxHeight: "calc(100vh - 165px)",
    overflow: "auto",
  },
  rsOrderPadGrid: {
    "&>div": {
      marginBottom: "30px",
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        background: `${theme.palette.background.grey} !important`,
        marginTop: "10px",
      },
    },
  },
  rsEarlyOrderGrid: {
    "&>div": {
      marginBottom: "30px",
      "&>h3": {
        fontSize: "20px !important",
      },
      "&>hr": {
        background: `${theme.palette.background.grey} !important`,
        marginTop: "10px",
      },
    },
  },
  rsOrderPadGeneralInfo: {
    padding: "17px 13px 25px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    marginBottom: "73px",
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "30px",
    },
    "&>div": {
      "&>h4": {
        marginBottom: "20px",
      },
      "&>div": {
        marginBottom: "20px",
      },
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadPatientSelect: {
    padding: "17px 13px",
    height: "296px",
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.background.default,
    "&>h3": {
      fontSize: "20px !important",
      marginBottom: "30px",
    },
    "&>hr": {
      marginBottom: "30px",
      background: `${theme.palette.background.grey} !important`,
    },
  },
  rsOrderPadMedicationBtn: {
    padding: "17px 13px 5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "10px !important",
    backgroundColor: "none !important",
    marginBottom: "30px",
  },
  rsOrderPadProceedBtn: {
    marginRight: "60px !important",
    fontSize: "16px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "50px !important",
  },
  rsPatientEditBtn: {
    fontSize: "14px !important",
    fontWeight: "400 !important",
    borderRadius: "5px !important",
    marginBottom: "0px !important",
    marginLeft: "20px !important",
  },
  tableBody: {
    "&>td": {
      padding: "10px 20px !important",
      borderBottom: `none !important`,
    },
    "& .MuiFormControlLabel-root": {
      marginLeft: "11px !important",
    },
  },
  labelWhiteSpaceNW: {
    "&>span": {
      whiteSpace: "nowrap",
    },
  },
  chipMain: {
    position: "relative",
    marginLeft: "10px",
    marginTop: "10px",
    height: "50px !important",
    minWidth: "170px !important",
    borderRadius: "5px !important",
    padding: "8px 20px !important",
    fontSize: "17px !important",
    cursor: "pointer  !important",
    "& .MuiChip-icon": {
      marginBottom: "5px !important",
      margin: "0px !important",
    },
    "&>svg": {
      width: "20px",
      height: "20px",
    },
    "&>span": {
      marginLeft: "10px  !important",
      padding: "0px  !important",

      "&>div": {
        "&>svg": {
          position: "absolute",
          top: "3px",
          right: "3px",
          width: "18px",
          height: "18px",
        },
      },
    },
  },
  chips: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    background: `${theme.palette.primary.main}10 !important`,
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.primary.main} !important`,
      },
    },
    "&:hover": {
      background: `${theme.palette.primary.main}20 !important`,
    },
  },
  chipsFilled: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.background.paper} !important`,
    background: `${theme.palette.primary.main} !important`,
    "&>svg": {
      "&>path": {
        fill: `${theme.palette.background.paper} !important`,
      },
    },
    "&:hover": {
      background: `rgb(86, 134, 47) !important`,
    },
  },
  manageDeletedIcon: {
    display: "block !important",
  },
  rsAddMedicationBtn: {
    marginLeft: "25px !important",
  },
  iconStyle: {
    marginRight: "10px",
    "&>path": {
      fill: "#e6b400",
      fillOpacity: "0.6",
    },
  },
  rsTextField: {
    marginBottom: "13px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginBottom: "-12px",
    },
  },
  rsDrugAutoCompleteBox: {
    marginBottom: "13px !important",
    "& .MuiFormHelperText-root.Mui-error": {
      marginTop: "3px !important",
    },
  },
  rsErrorHandle: {
    "&>label": {
      color: "rgba(0, 0, 0, 0.38) !important",
    },
  },
}));

const RepeatOrderToOrder = (props) => {
  const classes = useStyle();
  const {
    handleSubmit,
    selectedPatientInfo,
    query,
    setSelectedPatientInfo,
    setFieldValue,
    handlePatientDetailsChange,
    currentPageType,
    touched,
    repeatOrderToOrderPad,
    errors,
    values,
    handleChange,
    OrderBYList,
    orderBy,
    setOrderBy,
    orderType,
    showMedication,
    setOrderType,
    setShowMedication,
    setShowNoOfMedication,
    showNoOfMedication,
    checkAllAction,
    setCheckAllAction,
    medications,
    setMedications,
    handleChangeAction,
    medicationActionCheck,
    handleBlur,
    setCreateDrug,
    setIsOpenOrderList,
    showWholeForm,
    handleDialog,
    createOrderPadData,
    OrderingMethod,
    setUrgentDialog,
    validateDrug,
    blankMediation,
  } = props;
  const [ordertype, setOrdertype] = useState(
    repeatOrderToOrderPad?.data?.order_type
  );
  const [orderActionType, setOrderActionTypeActionType] = useState("");
  const [listOpen, setListOpen] = useState(false);
  const medicationRef = React.useRef(null);
  const quantityRef = React.useRef(null);
  const loginUserDetail = useSelector((state) => state.user);
  const showDataBasedOnRole =
    loginUserDetail?.loginUserDetail?.data?.data?.role;
  /**redirect  to drug  */
  useEffect(() => {
    let orderType = localStorage.getItem("order_type");
    if (orderType === "quick") {
      const element = document.getElementById("quick");
      if (element) {
        /**Will scroll smoothly to the top of the next section*/
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    if (orderType === "slow") {
      setUrgentDialog(true);
    }
    setOrdertype("");
  }, [repeatOrderToOrderPad]);

  /** handle click add drug  */
  const handleClickAddDrug = () => {
    setMedications(
      medications.concat([
        {
          id: "",
          name: "",
          quantity: "",
          action: false,
          errors: {
            name: "",
            quantity: "",
          },
          isNew: true,
        },
      ])
    );
  };

  /** handle drug change */
  const handleDrugChange = (e, index, rowInfo) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      ...(rowInfo
        ? {
            ...rowInfo,
            meditation_id: rowInfo.id,
          }
        : {
            id: "",
            name: "",
            meditation_id: "",
          }),
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };

  /** handle change quantity */
  const handleChangeQuantity = (e, index) => {
    const allDrug = medications;
    allDrug[index] = {
      ...allDrug[index],
      quantity: e.target.value,
    };
    setMedications([...allDrug]);
    validateDrug("onChange");
  };
  return (
    <>
      {repeatOrderToOrderPad?.data?.is_early_order === true && (
        <Grid
          container
          columnSpacing={2.5}
          rowSpacing={3}
          className={classes.rsEarlyOrderGrid}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Alert
              icon={<WarningIcon fontSize="inherit" />}
              severity="error"
              className={classes.rsAlert}
            >
              You are ordering this prescription early. If you order a
              prescription too early your order request may be rejected by the
              surgery.
            </Alert>
          </Grid>
        </Grid>
      )}
      <Grid className={classes.managePageH}>
        {repeatOrderToOrderPad?.loading ? (
          <PageLoading />
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();

              setTimeout(() => {
                const errorId = ["name", "quantity"];
                let foundError = false;
                for (let i = 0; i <= medications.length; i++) {
                  if (foundError) {
                    break;
                  }
                  for (let j = 0; j <= errorId.length; j++) {
                    const element = document.getElementById(
                      `${errorId[j]}_${i}`
                    );
                    if (
                      element?.parentElement?.nextSibling?.classList?.contains(
                        "Mui-error"
                      )
                    ) {
                      element.focus();
                      foundError = true;
                      break;
                    }
                  }
                }
              }, 1000);
            }}
          >
            <Grid
              container
              columnSpacing={2.5}
              rowSpacing={3}
              className={classes.rsOrderPadGrid}
            >
              <Grid item xs={5} sm={5} md={5} lg={4} xl={5}>
                <Paper
                  elevation={0}
                  className={classes.rsOrderPadPatientSelect}
                >
                  <Typography variant="h3" medium color="secondary">
                    Choose Patient Name
                  </Typography>
                  <Divider />
                  <RepeatOrderPatientAutoComplete
                    fullWidth
                    value={selectedPatientInfo}
                    disabled={query.get("actionType") === "repeatOrderPage"}
                    className={classes.autoCompleteBox}
                    onChange={(e, value) => {
                      setSelectedPatientInfo(value);
                      setFieldValue("patient_id", value?.id);
                      handlePatientDetailsChange(value);
                    }}
                    currentPageType={currentPageType}
                    orderType={orderType}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        autoFocus
                        label="Choose Patient Name *"
                        error={touched?.patient_id && errors?.patient_id}
                        helperText={touched?.patient_id && errors?.patient_id}
                      />
                    )}
                  />
                </Paper>
              </Grid>
              <Grid item xs={7} sm={7} md={7} lg={8} xl={7}>
                <Paper elevation={0} className={classes.rsOrderPadGeneralInfo}>
                  <Typography variant="h3" medium color="secondary">
                    General Information
                  </Typography>
                  <Divider />
                  <Box display={"flex"}>
                    <Grid item xs={6} sm={6} md={6} lg={6} marginRight={"20px"}>
                      <TextField
                        disabled
                        className={classes.marginTop}
                        variant="outlined"
                        fullWidth
                        placeholder="Name *"
                        label="Name *"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        name="name"
                        value={values?.name}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} md={6} lg={6}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          disabled
                          className={classes.rsErrorHandle}
                          disableFuture
                          label="Date of birth "
                          views={["year", "month", "day"]}
                          inputFormat="DD-MM-YYYY"
                          value={values?.dob ? values?.dob : null}
                          onChange={(newDate) => {
                            setFieldValue("dob", newDate);
                          }}
                          renderInput={(params) => (
                            <TextField
                              className={classes.marginTop}
                              fullWidth
                              size="small"
                              name="dob"
                              {...params}
                            />
                          )}
                          name="dob"
                        />
                      </LocalizationProvider>
                    </Grid>
                  </Box>
                  <Box display={"flex"}>
                    <Grid item xs={6} sm={6} md={6} lg={6} marginRight={"20px"}>
                      <SurgryAutoComplete
                        disabled
                        fullWidth
                        // multiple
                        className={classes.autoCompleteBox}
                        value={values?.surgery_info}
                        onChange={(e, value) => {
                          setFieldValue("surgery_info", value);
                          setFieldValue("surgery_id", value.id);
                        }}
                        renderInput={(params) => (
                          <TextField
                            className={classes.marginTop}
                            {...params}
                            label="Surgery *"
                          />
                        )}
                      />
                    </Grid>
                    {showDataBasedOnRole === "admin" && (
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={6}
                        lg={6}
                        style={{ marginBottom: "10px" }}
                      >
                        <PharmacyAutoComplete
                          disabled
                          fullWidth
                          // multiple
                          className={classes.autoCompleteBox}
                          value={values?.pharmacy_info}
                          onChange={(e, value) => {
                            setFieldValue("pharmacy_info", value);
                            setFieldValue("pharmacy_id", value.id);
                          }}
                          renderInput={(params) => (
                            <TextField
                              className={classes.marginTop}
                              {...params}
                              label="Pharmacy *"
                            />
                          )}
                        />
                      </Grid>
                    )}
                  </Box>
                  {query.get("actionType") === "createNewRx" && (
                    <Box display={"flex"}>
                      {OrderBYList?.map((item, index) => {
                        return (
                          <FormControlLabel
                            className={classes.labelWhiteSpaceNW}
                            value={item}
                            key={index}
                            checked={orderBy === item.type}
                            onChange={(e, value) => {
                              setOrderBy(item.type);
                            }}
                            control={
                              <Checkbox
                                icon={<RadioButtonUncheckedIcon />}
                                checkedIcon={<RadioButtonCheckedIcon />}
                                color="primary"
                              />
                            }
                            label={`${item.item}  ordered`}
                          />
                        );
                      })}
                    </Box>
                  )}
                </Paper>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                xl={12}
                id={
                  repeatOrderToOrderPad?.data?.order_type === "quick"
                    ? "quick"
                    : ""
                }
              >
                <Paper elevation={0} className={classes.rsOrderPadGeneralInfo}>
                  <Typography variant="h3" medium color="secondary">
                    Medicine details
                  </Typography>
                  <Divider />
                  <Box display={"flex"}>
                    <FormGroup>
                      <FormControlLabel
                        className={classes.rsSurgryFormControl}
                        control={
                          <Checkbox
                            color="primary"
                            checked={showMedication}
                            onChange={() => {
                              setOrderType("medication");
                              setShowMedication(!showMedication);
                              setShowNoOfMedication(false);
                              setListOpen(false);
                            }}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                          />
                        }
                        label="Select Specific Medications"
                      />
                    </FormGroup>
                    <FormGroup>
                      <FormControlLabel
                        className={classes.rsSurgryFormControl}
                        control={
                          <Checkbox
                            color="primary"
                            checked={showNoOfMedication}
                            onChange={() => {
                              setOrderType("numberOfMedication");
                              setShowNoOfMedication(!showNoOfMedication);
                              setShowMedication(false);
                            }}
                            icon={<RadioButtonUncheckedIcon />}
                            checkedIcon={<RadioButtonCheckedIcon />}
                          />
                        }
                        label="Select Number Of Medications"
                      />
                    </FormGroup>
                  </Box>
                  {showMedication && !showNoOfMedication && (
                    <Grid item xs={12}>
                      <Table stickyHeader id="quantity">
                        <TableHead className={classes.tableHead}>
                          <TableRow>
                            <TableCell style={{ width: "50%" }}>
                              <div style={{ display: "flex" }}>
                                DRUG{" "}
                                <div
                                  style={{
                                    color: "red",
                                    marginLeft: "5px",
                                  }}
                                >
                                  *
                                </div>{" "}
                              </div>
                            </TableCell>
                            <TableCell style={{ width: "10%" }}>
                              QUANTITY
                            </TableCell>
                            <TableCell style={{ width: "5%" }}>
                              <Box
                                display={"flex"}
                                alignItems={"center"}
                                justifyContent={"space-around"}
                              >
                                ACTION
                                <FormGroup style={{ marginLeft: "10px" }}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        checked={checkAllAction}
                                        onChange={(e, value) => {
                                          const isChecked = !checkAllAction;
                                          setCheckAllAction(isChecked);
                                          //Tick un tick medication
                                          const _medications = medications?.map(
                                            (item) => {
                                              item.action = isChecked;
                                              return item;
                                            }
                                          );
                                          setMedications(_medications);
                                        }}
                                      />
                                    }
                                  />
                                </FormGroup>
                              </Box>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {medications.map((item, index) => {
                            return (
                              <TableRow className={classes.tableBody}>
                                <TableCell>
                                  <DrugAutoComplete
                                    listOpen={listOpen}
                                    fullWidth
                                    disabled={!item.isNew}
                                    filterMedication={medications}
                                    className={classes.rsDrugAutoCompleteBox}
                                    value={item}
                                    onChange={(e, value) => {
                                      value = value
                                        ? {
                                            ...value,
                                            name: value?.label,
                                          }
                                        : value;
                                      delete value?.label;
                                      handleDrugChange(e, index, value);
                                      handleChange("drug", value);
                                      quantityRef.current.focus();
                                    }}
                                    orderActionType={orderActionType}
                                    onBlur={handleBlur}
                                    id={`name_${index}`}
                                    renderInput={(params) => (
                                      <>
                                        <TextField
                                          {...params}
                                          inputRef={
                                            orderActionType === "orderCreate"
                                              ? medicationRef
                                              : ""
                                          }
                                          id={`name_${index}`}
                                          autoFocus={
                                            orderActionType === "orderCreate"
                                          }
                                          label="Drug Name"
                                          placeholder="Choose Drug"
                                          error={
                                            item?.errors?.name &&
                                            item?.errors?.name
                                          }
                                          helperText={
                                            item?.errors?.name &&
                                            item?.errors?.name
                                          }
                                          onBlur={handleBlur}
                                        />
                                      </>
                                    )}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    variant="outlined"
                                    fullWidth
                                    inputRef={quantityRef}
                                    disabled={!item.isNew}
                                    placeholder="Quantity"
                                    inputProps={{ maxLength: 10 }}
                                    label="Quantity"
                                    size="small"
                                    value={item.quantity}
                                    name={`medications[${index}]`}
                                    onChange={(e, value) => {
                                      handleChangeQuantity(e, index);
                                      handleChange(e);
                                    }}
                                    error={
                                      item?.errors?.quantity &&
                                      item?.errors?.quantity
                                    }
                                    helperText={
                                      item?.errors?.quantity &&
                                      item?.errors?.quantity
                                    }
                                    onBlur={handleBlur}
                                    className={classes.rsTextField}
                                    id={`quantity_${index}`}
                                  />
                                </TableCell>
                                <TableCell>
                                  <FormGroup
                                    className={classes.manageDeletedIcon}
                                  >
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          color="primary"
                                          checked={item?.action}
                                          disabled={item?.is_deleted}
                                          onChange={(e, value) => {
                                            handleChangeAction(e, index);
                                          }}
                                        />
                                      }
                                    />
                                    {item?.is_deleted && (
                                      <HtmlTooltipMain
                                        title={"Deleted in last record"}
                                      >
                                        <IconButton className={classes.iconBtn}>
                                          <ErrorIcon width="20px" />
                                        </IconButton>
                                      </HtmlTooltipMain>
                                    )}
                                  </FormGroup>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </Grid>
                  )}
                  {showNoOfMedication && !showMedication && (
                    <Grid item xs={4} sm={4} md={4} lg={4}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Total Medication"
                        label="Total Medication"
                        size="small"
                        type="number"
                        name="number_of_medication"
                        value={values?.number_of_medication}
                        error={
                          touched?.number_of_medication &&
                          errors?.number_of_medication
                        }
                        helperText={
                          touched?.number_of_medication &&
                          errors?.number_of_medication
                        }
                        onChange={handleChange}
                        onBlur={handleBlur}
                        InputLabelProps={{
                          shrink:
                            query.get("actionType") === "repeatOrderPage" ||
                            repeatOrderToOrderPad?.data?.number_of_medication ||
                            showNoOfMedication
                              ? true
                              : false,
                        }}
                      />
                    </Grid>
                  )}
                </Paper>
                <Grid item xs={6} sm={6} md={12} lg={12}>
                  <Box display={"flex"}>
                    <Button
                      className={classes.rsPatientEditBtn}
                      variant="contained"
                      disabled={
                        values?.number_of_medication &&
                        medicationActionCheck.length !== 0
                      }
                      startIcon={
                        <PrimaryIcon
                          icon={EditIconTwo}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        setCreateDrug(true);
                      }}
                    >
                      Edit Patient
                    </Button>
                    <Button
                      className={classes.rsAddMedicationBtn}
                      variant="contained"
                      disabled={
                        values?.number_of_medication ||
                        blankMediation.length > 0
                      }
                      startIcon={
                        <PrimaryIcon
                          icon={AddIcon}
                          color="white"
                          width="16px"
                          height="16px"
                        />
                      }
                      onClick={() => {
                        setOrderActionTypeActionType("orderCreate");
                        handleClickAddDrug();
                        setListOpen(true);
                        medicationRef?.current?.focus();
                      }}
                    >
                      Add Medication
                    </Button>
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper
                  elevation={0}
                  className={classes.rsOrderPadMedicationBtn}
                >
                  <Grid
                    container
                    columnSpacing={2.5}
                    rowSpacing={3}
                    className={classes.rsOrderPadGrid}
                  >
                    <Grid item xs={12}>
                      <Typography variant="h3" medium color="secondary">
                        Order Details
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>

                    {/* <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        placeholder="Order comment"
                        label="Order comment"
                        size="small"
                        name="comment"
                        value={values?.comment}
                        error={touched?.comment && errors?.comment}
                        helperText={touched?.comment && errors?.comment}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Grid>
                        <Typography medium variant="h4">
                          Best Ordering Method *
                        </Typography>
                        <Grid
                          display={"flex"}
                          style={{
                            marginTop: "20px",
                            marginBottom: "20px",
                            justifyContent: "space-around",
                          }}
                          rowSpacing={1}
                          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                        >
                          <>
                            {OrderingMethod?.map((item, index) => {
                              return (
                                <FormControlLabel
                                  error={
                                    touched?.ordering_method &&
                                    errors?.ordering_method
                                  }
                                  helperText={
                                    touched?.ordering_method &&
                                    errors?.ordering_method
                                  }
                                  onBlur={handleBlur}
                                  className={classes.labelWhiteSpaceNW}
                                  value={item}
                                  key={index}
                                  onClick={() => {
                                    handleDialog(
                                      medications,
                                      values?.number_of_medication,
                                      item?.type
                                    );

                                    setIsOpenOrderList(false);
                                    setFieldValue(
                                      "ordering_method",
                                      item?.type || ""
                                    );
                                    handleChange(
                                      "ordering_method",
                                      item?.type || ""
                                    );
                                  }}
                                  control={
                                    <Chip
                                      icon={item?.icon}
                                      checked={
                                        values?.ordering_method == item.type
                                      }
                                      className={clsx(
                                        classes.chipMain,
                                        values?.ordering_method == item.type
                                          ? classes.chipsFilled
                                          : classes.chips
                                      )}
                                      label={<div>{item?.item}</div>}
                                      color={
                                        values?.ordering_method == item.type
                                          ? "primary"
                                          : "default"
                                      }
                                      variant={
                                        values?.ordering_method == item.type
                                          ? "filled"
                                          : "outlined"
                                      }
                                    />
                                  }
                                />
                              );
                            })}
                          </>
                        </Grid>
                        <FormHelperText
                          error={
                            touched?.ordering_method && errors?.ordering_method
                          }
                          style={{ marginTop: "-10px", marginBottom: "20px" }}
                        >
                          {touched?.ordering_method && errors?.ordering_method}
                        </FormHelperText>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
            {showWholeForm && (
              <>
                <Grid container columnSpacing={2.5} rowSpacing={2}>
                  <Box display={"flex"} margin={"0 auto"}>
                    <Grid item xs={3} sm={6} md={6} lg={6}>
                      <Button
                        variant="contained"
                        type="submit"
                        disabled={createOrderPadData?.loading}
                        startIcon={
                          createOrderPadData?.loading && (
                            <CircularProgress color="white" size="20px" />
                          )
                        }
                        className={classes.rsOrderPadProceedBtn}
                      >
                        Proceed
                      </Button>
                    </Grid>
                  </Box>
                </Grid>
              </>
            )}
          </form>
        )}
      </Grid>
    </>
  );
};

export default RepeatOrderToOrder;
